/* Small render helpers shared by surfaces. All return HTML strings; the shell sets innerHTML. */
import type { Stamped } from '../store/types';

export const esc = (s: string): string =>
  s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c] as string);

/** The "as of <time> · source" stamp rendered on every tile (spec §4.1). */
export function stampLine<T>(s: Stamped<T>): string {
  const t = new Date(s.generated_at).toLocaleString();
  const tag = s.freshness === 'fresh' ? '' : ` · ${s.freshness.toUpperCase()}`;
  return `<div class="stamp">as of ${esc(t)} · ${esc(s.source)}${tag}</div>`;
}

export function surfaceTitle(t: string): string {
  return `<div class="surface-title">${esc(t)}</div>`;
}

export function loading(): string {
  return `<div class="loading">Loading…</div>`;
}

export function card(inner: string, fill = ''): string {
  return `<div class="card ${fill}">${inner}</div>`;
}

/** An honest inline note for a failure / not-wired / offline state.
 *  Used instead of ever faking a value when the bridge can't serve real data. */
export function note(msg: string): string {
  return `<div class="softfail">${esc(msg)}</div>`;
}

/** Banner shown at the top of a surface whose data came back `offline`
 *  (the feed isn't wired to a live source yet) — honest, never a fake tile. */
export function offlineBanner(source: string): string {
  return `<div class="softfail">Not wired to a live source yet${
    source ? ` (${esc(source)})` : ''
  } — this surface will show real data once its feed is connected.</div>`;
}
